import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TSourceDetail } from '@core/interfaces/TMessage';

import { CustomButtonComponent } from '../custom-button/custom-button.component';
import { OriginalResourceModalComponent } from './original-resource-modal/original-resource-modal.component';

@Component({
    selector: 'app-show-original-resources',
    templateUrl: './show-original-resources.component.html',
    styleUrls: ['./show-original-resources.component.css'],
    standalone: true,
    imports: [CustomButtonComponent]
})
export class ShowOriginalResourcesComponent {
  @Input() originalSources: TSourceDetail[] = [];

  constructor(private _dialog: MatDialog) {}

  openModal() {
    this._dialog.open(OriginalResourceModalComponent, {
      data: { sourceDetails: this.originalSources },
      width: '80vw',
      height: '100vh',
      maxWidth: '80vw',
      maxHeight: '100vh',
      position: { right: '0' },
      panelClass: 'original-resource-modal',
      hasBackdrop: true,
      disableClose: false,
    });
  }
}
